import React from 'react';
import { formStyles } from '../../constants/SiteVariables';
import { ErrorMessage } from 'formik';
import Input from './Input';

export default function StickyInput(props) {
  if (!props.id || !props.placeholder) throw 'Missing required props';

  return (
    <div className="field sticky-placeholder">
      <div className="control">
        <Input {...props}/>
        <label className="placeholder" htmlFor={props.id}>{props.placeholder}</label>
        {props.disclaimer && props.disclaimer}
        <ErrorMessage name={props.id} component="div" className={formStyles.validation} />
      </div>
    </div>
  );
}
